var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _dec7, _class2, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import AutoRefreshingTraits from "./AutoRefreshingTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import GtfsModelTraits from "./GtfsModelTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import OpacityTraits from "./OpacityTraits";
import ScaleByDistanceTraits from "./ScaleByDistanceTraits";
import UrlTraits from "./UrlTraits";
export let HeadersTraits = (_dec = primitiveTrait({
  name: "Name",
  description: "The header name",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Value",
  description: "The header value",
  type: "string"
}), _class = class HeadersTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "value", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let GtfsCatalogItemTraits = (_dec3 = traitClass({
  description: "Creates one catalog item from url that points to a gtfs service.\n  \n  <strong>Note:</strong> \n  <li>You need to obtain a valid api key for the NSW transport api.</li>\n  <li>When the camera is less than <code>maximumDistance</code> (500m) away, bus 3d models (scene.gltf) will be rendered.</li>",
  example: {
    type: "gtfs",
    url: "https://api.transport.nsw.gov.au/v1/gtfs/vehiclepos/buses",
    image: "https://tiles.terria.io/terriajs-examples/gtfs/TfNSW_B.png",
    name: "NSW Live Transport - Buses",
    headers: [{
      name: "Authorization",
      value: "apikey put-a-real-api-key-here"
    }],
    refreshInterval: 60,
    featureInfoTemplate: {
      name: "{{vehicle_trip_bus_number}}",
      template: "<b>Bus:</b> {{route_short_name}}<br><b>Occupancy:</b> {{occupancy_status_str}}<br><b>Speed:</b> {{speed_km}} km/h<br><b style='padding-right: 5px'>Direction:</b> <span style='transform: rotate({{bearing}}deg); width: 10px; display: inline-block' aria-label='{{bearing}} degrees' role='img' title='{{bearing}} degrees'>&#x2B06;</div>"
    },
    model: {
      url: "https://tiles.terria.io/terriajs-examples/gtfs/lowpoly_bus/scene.gltf",
      scale: 0.3048,
      maximumDistance: 500.0
    },
    id: "some unique id"
  }
}), _dec4 = objectArrayTrait({
  name: "Headers",
  description: "Extra headers to attach to queries to the GTFS endpoint",
  type: HeadersTraits,
  idProperty: "name"
}), _dec5 = primitiveTrait({
  name: "Image url",
  description: "Url for the image to use to represent a vehicle. Recommended size 32x32 pixels.",
  type: "string"
}), _dec6 = objectTrait({
  name: "Scale Image by Distance",
  description: "Describes how marker images are scaled by distance from the viewer.",
  type: ScaleByDistanceTraits
}), _dec7 = objectTrait({
  name: "Model",
  description: "3D model to use to represent a vehicle.",
  type: GtfsModelTraits
}), _dec3(_class2 = (_class3 = class GtfsCatalogItemTraits extends mixTraits(UrlTraits, CatalogMemberTraits, LegendOwnerTraits, MappableTraits, OpacityTraits, LayerOrderingTraits, AutoRefreshingTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "headers", _descriptor3, this);
    _initializerDefineProperty(this, "image", _descriptor4, this);
    _initializerDefineProperty(this, "scaleImageByDistance", _descriptor5, this);
    _initializerDefineProperty(this, "model", _descriptor6, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "headers", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "image", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "scaleImageByDistance", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "model", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3)) || _class2);
export { GtfsCatalogItemTraits as default };